/**
 * SIMPLE PROTECTION FOR PRIVATE PAGES
 * ===================================
 * This wrapper keeps the app from showing staff-only pages to someone who has not signed in yet.
 *
 * If the user is already logged in, the page content is shown.
 * If not, they are sent to the SWA sign-in flow and returned here afterward.
 */

import { useEffect } from "react";
import { useAuth } from "@/components/Auth/AuthContext";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const { isAuthenticated, isLoading, login } = useAuth();

  useEffect(() => {
    // Once the first sign-in check is done, send unauthenticated users to the login page.
    if (!isLoading && !isAuthenticated) {
      console.log('❌ RequireAuth: User not authenticated, redirecting to login');
      login(window.location.pathname + window.location.search + window.location.hash);
    }
  }, [isLoading, isAuthenticated, login]);

  // Hide the protected page while we are still checking or redirecting.
  if (isLoading || !isAuthenticated) {
    console.log('🔄 RequireAuth: Loading or not authenticated, showing nothing');
    return null;
  }

  // At this point the user is allowed in, so show the real page.
  console.log('✅ RequireAuth: User authenticated, rendering protected content');
  return children;
}
